import { render } from "./LoginRenewal.vue?vue&type=template&id=390f8b07"
import script from "./LoginRenewal.vue?vue&type=script&lang=js"
export * from "./LoginRenewal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__